/**
 * Login reducers index script file
 *
 * @package    Reducers
 * @author     Ihor Anishchenko <ianischenko@mindk.com>
 * @copyright  Copyright (c) 2010-2018 MindK (http://mindk.com). All rights reserved.
 * @license    http://mindk.com
 * @link       http://mindk.com
 */

import Immutable from 'seamless-immutable';
import {
    USER_DATA_REQUEST,
    USER_DATA_SUCCESS,
    USER_DATA_ERROR,
    USER_UPDATE_REQUEST,
    USER_UPDATE_SUCCESS,
    USER_UPDATE_ERROR,
    MY_PROFILE_UPDATE_REQUEST,
    MY_PROFILE_UPDATE_SUCCESS,
    MY_PROFILE_UPDATE_ERROR,
    USER_DATA_CLEAR,
} from 'Actions/user';

export const INITIAL_STATE = Immutable({
    loading: false,
    success: false,
    error: false,
    user: {
        first_name: null,
        last_name: null,
        email: null,
    },
});

export default function userDataReducer(state = INITIAL_STATE, action) {
    switch (action.type) {
        case USER_DATA_REQUEST:
        case USER_UPDATE_REQUEST:
        case MY_PROFILE_UPDATE_REQUEST:
            return state.merge({
                loading: true,
                success: false,
                error: false,
            });

        case USER_DATA_SUCCESS:
        case USER_UPDATE_SUCCESS:
        case MY_PROFILE_UPDATE_SUCCESS: {
            let userData = action.payload.data;
            if ('profile' in userData) {
                if (userData.profile) {
                    userData = { ...userData.profile, ...userData };
                }
                delete userData.profile;
            }

            if ('interests' in userData) {
                if (Array.isArray(userData.interests)) {
                    userData.interests = userData.interests.map(item => item.id);
                } else {
                    userData.interests = [];
                }
            }

            return state.merge({
                loading: false,
                success: true,
                error: false,
                user: userData,
            });
        }

        case USER_UPDATE_ERROR:
        case USER_DATA_ERROR:
        case MY_PROFILE_UPDATE_ERROR:
            return state.merge({
                loading: false,
                success: false,
                error: true,
            });

        case USER_DATA_CLEAR:{
            return INITIAL_STATE;
        }

        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/userDataReducer.js